import { render, staticRenderFns } from "./language_codes.vue?vue&type=template&id=ca3bd912&scoped=true&"
import script from "./language_codes.vue?vue&type=script&lang=js&"
export * from "./language_codes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3bd912",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca3bd912')) {
      api.createRecord('ca3bd912', component.options)
    } else {
      api.reload('ca3bd912', component.options)
    }
    module.hot.accept("./language_codes.vue?vue&type=template&id=ca3bd912&scoped=true&", function () {
      api.rerender('ca3bd912', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/language_codes.vue"
export default component.exports